<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="行政处罚决定书文号" >
            <template slot-scope="scope">
              {{ scope.row.sanc_deci_doc_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="行政处罚机关">
            <template slot-scope="scope">
              {{ scope.row.sanction_agency_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="案件案由">
            <template slot-scope="scope">
              {{ scope.row.case_cause_of_action || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="主要违法内容" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.main_illegal_content || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="公示日期">
            <template slot-scope="scope">
              {{ scope.row.announcement_date || '-' }}
            </template>
        </el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
    name: 'sanctionList',
    data() {
        return {
            title: '行政处罚',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>